export enum PosterEditorItemFilters {
  BLACK_AND_WHITE = 'BLACK_AND_WHITE',
  SEPIA = 'SEPIA',
  INVERT = 'INVERT',
}

export interface PosterEditorItemFiltersData {
  filter: PosterEditorItemFilters;
  thumbnail: string;
}

export const PosterEditorItemFiltersDataArray: Array<PosterEditorItemFiltersData> = [
  {
    filter: PosterEditorItemFilters.BLACK_AND_WHITE,
    thumbnail: 'black_and_white',
  },
  {
    filter: PosterEditorItemFilters.SEPIA,
    thumbnail: 'sepia',
  },
  {
    filter: PosterEditorItemFilters.INVERT,
    thumbnail: 'invert',
  },
];
